import React, { useId, useState } from "react";
import classNames from "classnames";
import { Radio } from "./Radio";
import { RadioGroupProps } from "./typer";
import { SVVFormError } from "./FormError";
import { SVVPopover } from "./Popover";

function Component({
  onChange,
  options,
  selected,
  legend,
  required = false,
  errorMessage = "",
  name,
  direction = "horizontal",
  popoverText,
  popoverTitle,
  removeMargin = false,
  isFullWidth,
  description,
  sm,
  id,
}: RadioGroupProps) {
  const [feilmeldingId] = useState(`feilmelding-${useId()}`);
  return (
    <fieldset
      className={classNames("svv-form-element", {
        "svv-form-element--inline": direction === "horizontal",
        "svv-form-element--with-errors": errorMessage,
        "svv-form-element--margin-bottom": !removeMargin,
        "svv-form-element--max-width": !isFullWidth,
      })}
      id={id}
    >
      <legend className="svv-form-label">
        {legend}
        {required && <span aria-hidden="true"> *</span>}
        {popoverTitle && popoverText && (
          <SVVPopover title={popoverTitle} explanationText={popoverText} />
        )}
      </legend>
      {description && <p className="svv-form-description">{description}</p>}
      {options.map((o) => (
        <Radio
          key={o.value}
          name={name}
          onChange={onChange}
          value={o.value}
          text={o.text}
          checked={o.value === selected}
          required={required || false}
          ariaDescribedby={errorMessage ? feilmeldingId : undefined}
          disabled={o.disabled}
          description={o.description}
          description2={o.description2}
          description3={o.description3}
          ref={o.ref}
          sm={sm}
        />
      ))}
      <div aria-live="assertive">
        {errorMessage && <SVVFormError id={feilmeldingId}>{errorMessage}</SVVFormError>}
      </div>
    </fieldset>
  );
}

export const SVVRadioGroup = Component as React.FC<RadioGroupProps>;

SVVRadioGroup.displayName = "SVVRadioGroup";
